import { OrderDataResponseDto, OrderResponseDto } from "../dto/response/order-response-dto";
import { Order, OrderData } from "../model/order-model";

export function orderDataMapper(order: OrderDataResponseDto): OrderData {
  return {
    id: order.id,
    addressId: order.addressId,
    paymentType: order.paymentType,
    shippingSpeed: order.shippingSpeed,
    deliveryMethodId: order.deliveryMethodId,
    installments: order.installments,
    totalAmountDiscount: order.totalAmountDiscount,
    totalAmountShipping: order.totalAmountShipping,
    totalAmountProducts: order.totalAmountProducts,
    totalAmount: order.totalAmount,
    createdAt: order.createdAt,
    updatedAt: order.updatedAt,
    products: order.orderProducts.map((product) => ({
      id: product.id,
      name: product.name,
      quantity: product.quantity,
      color: product.color,
      size: product.size,
      price: product.price,
      image: product.image})),
    orderStatus: order.orderStatus,
    address: {
      ...order?.address,
      uf: order?.address?.stateCode},
    billing: order.billing,
    invoice: order.invoice,
    // compute cancelable: only if last status is DELIVERED and updatedAt <= 7 days
    cancelable: (() => {
      const statuses = order.orderStatus ?? [];
      const lastStatus = statuses[statuses.length - 1];
      const lastName = (lastStatus?.name || "").toString().toUpperCase();
      if (lastName !== "DELIVERED") return false;
      if (!order.updatedAt) return false;
      const deliveredDate = new Date(order.updatedAt);
      const now = new Date();
      const diffDays = (now.getTime() - deliveredDate.getTime()) / (1000 * 60 * 60 * 24);
      return diffDays <= 7;
    })()};
}

export function orderMapper(dto: OrderResponseDto): Order {
  const dataArray = dto.data.map(orderDataMapper);
  return {
    data: {
      [dto.pagination.page]: dataArray},
    pagination: {
      total: dto.pagination.total,
      page: dto.pagination.page,
      pageSize: dto.pagination.pageSize,
      totalPage: dto.pagination.totalPage}};
}
